export enum Applications {
  LINDENBERG = 'lindenberg',
  PROTOCOLLO = 'protocollo',
  TIMETRACK = 'timetrack',
}
